import { render, staticRenderFns } from "./roleEdit.vue?vue&type=template&id=4adc0b76"
import script from "./roleEdit.vue?vue&type=script&lang=js"
export * from "./roleEdit.vue?vue&type=script&lang=js"
import style0 from "./roleEdit.vue?vue&type=style&index=0&id=4adc0b76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports